var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"10px 20px"}},[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("网点服务")]),_c('p',{staticStyle:{"font-size":"14px","color":"#666666","text-align":"left"}},[_c('span',{staticStyle:{"margin-left":"20px"}}),_vm._v("加入专属网点，可以根据所属区域选择附近的日日顺服务网点。主要注册日日顺快线网点服务，经过身份验证，就可以抢单赚钱，海量订单，收入稳定，全职工作。")])])
}]

export { render, staticRenderFns }